import { render, staticRenderFns } from "./EditSqc.vue?vue&type=template&id=1fce3f54&lang=true&"
import script from "./EditSqc.vue?vue&type=script&lang=js&"
export * from "./EditSqc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports